( function () {
	'use strict';

	var closedDetails = [];
	var printMedia = window.matchMedia( 'print' );

	function expandDetails() {
		if ( closedDetails.length ) {
			return;
		}

		closedDetails = Array.prototype.filter.call(
			document.querySelectorAll( 'details' ),
			function ( details ) {
				return ! details.open;
			}
		);

		closedDetails.forEach( function ( details ) {
			details.open = true;
		} );
	}

	function restoreDetails() {
		closedDetails.forEach( function ( details ) {
			details.open = false;
		} );

		closedDetails = [];
	}

	window.addEventListener( 'beforeprint', expandDetails );
	window.addEventListener( 'afterprint', restoreDetails );
	printMedia.addEventListener( 'change', function ( event ) {
		if ( event.matches ) {
			expandDetails();
		} else {
			restoreDetails();
		}
	} );
}() );
